import settings from './settings'
import consultant from './consultants'
export default {
	settings,
	consultant,
	name:'name'
}
